const   objectionTrackActions = {
 


    GET_OBJECTION_COURSES : 'GET_OBJECTION_COURSES',
    SET_OBJECTION_COURSES : 'SET_OBJECTION_COURSES',

    RAISE_OBJECTION_DETAILS_CREATION: 'RAISE_OBJECTION_DETAILS_CREATION',

    GET_CANDIDATE_OBJECTION_DETAILS : 'GET_CANDIDATE_OBJECTION_DETAILS',
    SET_CANDIDATE_OBJECTION_DETAILS : 'SET_CANDIDATE_OBJECTION_DETAILS',


    GET_OBJECTION_DELETE : 'GET_OBJECTION_DELETE',
    SET_OBJECTION_DELETE : 'SET_OBJECTION_DELETE',


    RAISE_OBJECTION_BUTTON_CLICK : 'RAISE_OBJECTION_BUTTON_CLICK',

    GET_OBJ_CREDENTIAL : 'GET_OBJ_CREDENTIAL',
    SET_OBJ_CREDENTIAL : 'SET_OBJ_CREDENTIAL',

    GET_OBJ_QUESTIONS : 'GET_OBJ_QUESTIONS',
    SET_OBJ_QUESTIONS : 'SET_OBJ_QUESTIONS',

};

export default objectionTrackActions;